import React from "react";
import { FaPassport } from "react-icons/fa6";
import { DetailCard } from "../../Helpers/Components/Needed";
import { formatDob } from "../../Helpers/Utils";

const Passport = (data) => {
    return (
        <React.Fragment>
            <DetailCard title="Passport Details" icon={<FaPassport />}>
                <div className="mb-4">
                    <div className="info-grid px-3" >
                        <div className="info-field">
                            <div className="info-field-label"> Full Name </div>
                            <div className="info-value">{data?.rejected?.detail?.full_name || "-"}</div>
                        </div>
                        <div className="info-field">
                            <div className="info-field-label"> Date of Birth </div>
                            <div className="info-value">{formatDob(data?.rejected?.detail?.dob) || "-"}</div>
                        </div>
                        <div className="info-field">
                            <div className="info-field-label"> Passport Number </div>
                            <div className="info-value">{data?.rejected?.detail?.passport_number || "-"}</div>
                        </div>
                        <div className="info-field">
                            <div className="info-field-label"> File No </div>
                            <div className="info-value">{data?.rejected?.detail?.file_number || "-"}</div>
                        </div>
                        <div className="info-field">
                            <div className="info-field-label"> Date of Application </div>
                            <div className="info-value">{data?.rejected?.detail?.date_of_application || "-"}</div>
                        </div>
                        <div className="info-field">
                            <div className="info-field-label"> Application Type </div>
                            <div className="info-value">{data?.rejected?.detail?.application_type || "-"}</div>
                        </div>
                        <div className="info-field">
                            <div className="info-field-label"> Status </div>
                            <div className="info-value">{data?.rejected?.detail?.status || "-"}</div>
                        </div>
                    </div>
                </div>
                {
                    data?.rejected?.photo?.length ?
                        <div className="my-3">
                            <div className="row">
                                {
                                    data?.rejected?.photo?.map((ele, i) => {
                                        return (
                                            <div className="col-md-6 my-2" key={ele}>
                                                <div className="aadhaar-images">
                                                    <img src={ele} alt="Aadhaar" />
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                        : ""
                }
            </DetailCard>
        </React.Fragment>
    )
}

export default Passport;